import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, SearchField, UseFormReturnType } from '@frontend/design-system';
import { SourceDropdownFilterChip } from '../../../../../components/source-dropdown-filter-chip';
import type { SourceDropdownFilterOptions } from '../../../../../hooks/use-get-source-dropdown-filter-details';

type FormConfig = {
  search: { type: 'text'; value: string };
};

type Props = {
  showSourceDropdown: boolean;
  showSearchbox: boolean;
  sourceOptions: SourceDropdownFilterOptions;
  getFieldProps: UseFormReturnType<FormConfig, keyof FormConfig>['getFieldProps'];
  onSelectedSourcesChange: (values: string[]) => void;
  refetch: () => void;
};

export const Header = ({
  showSearchbox,
  showSourceDropdown,
  onSelectedSourcesChange,
  refetch,
  getFieldProps,
  sourceOptions,
}: Props) => {
  return (
    <div css={headerStyles}>
      {showSourceDropdown && (
        <SourceDropdownFilterChip sourceOptions={sourceOptions} onChange={onSelectedSourcesChange} />
      )}
      {showSearchbox && (
        <div css={{ width: 300, marginLeft: 'auto' }}>
          <SearchField {...getFieldProps('search')} />
        </div>
      )}
      {showSearchbox && (
        <NakedButton css={{ padding: theme.spacing(0, 3) }} onClick={refetch}>
          <Icon name='update' css={{ marginLeft: theme.spacing(1) }} />
        </NakedButton>
      )}
    </div>
  );
};

const headerStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
});
